import $ from 'jquery';

$('.accordion__element').each(function (){
    const $contentWrap = $(this).find('.accordion__content-wrap');
    const $check = $(this).find('.accordion__check');
    setTabindex($contentWrap, $check.prop('checked'));
})

$('.accordion__header').on('click', function (e) {
    e.preventDefault();

    const $parent = $(this).closest('.accordion__element');
    const $contentWrap = $parent.find('.accordion__content-wrap');
    const $check = $parent.find('.accordion__check');
    if($(this).closest('.accordion--radio').length > 0 && $check.prop('checked')) {
        $check.prop('checked', false);
    } else {
        $($(this).attr('href')).trigger('click');
    }

    setTabindex($contentWrap, $check.prop('checked'));
})

function setTabindex($target, checked) {
    let $clickables = $target.find('button, a, input, select, textarea');
    if (checked) {
        $target.removeAttr('aria-hidden')
        $clickables.removeAttr('tabindex');
    } else {
        $clickables.attr('tabindex', -1);
        $target.attr('aria-hidden', true)
    }
}


